import { Injectable } from '@angular/core';

declare const window: any;
const environment: string = (window ? window['environment'] : 'prod') ?? 'prod';

const appEngineHostMap: { [key: string]: string } = {
  local: 'http://localhost:8088',
  test: '',
  demo: 'vbilling-demo.appspot.com',
  prod: 'vbilling-prod.appspot.com',
  production: 'vbilling-prod.appspot.com',
};

@Injectable({ providedIn: 'root' })
export class BillingHostService {
  get appEngineHost(): string {
    const host = appEngineHostMap[environment.toLowerCase()];
    if (!host) {
      throw new Error('Could not getting billing host');
    }
    return 'https://' + host;
  }
}
